export default __webpack_public_path__ + "static/media/$50.9d783f66.png";